import styled from 'styled-components';

export const SeriesSelectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SearchContinaer = styled.div`
  width: 400px;
`;

export const DropdownsContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const SubFilterContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
`;

export const NoUnlockedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
`;

export const RecentChecklistsRow = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

export const RecentChecklistsLabel = styled.span`
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
`;

export const RecentChecklistsScroll = styled.div`
  display: flex;
  gap: 8px;
  flex: 1;
  flex-wrap: nowrap;
  min-width: 0;
  overflow-x: auto;

  h5 {
    flex: 0 0 auto;
    white-space: nowrap;
  }
`;

export const ErrorMessageContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 24px 0px;
`
